module.exports = __webpack_public_path__ + "img/ctrl-canonical-stub-up-+.14934706.svg";